import React from 'react';
import {
  Route,
  Redirect,
} from 'react-router';
import { withHandlers } from 'recompose';
import ShopMainLayout from '../components/ShopMainLayout';
import WithBarberUrlPattern from '../hoc/WithBarberUrlPattern';
import Barbers from '../barbers/Barbers';
import Services from './barber/Services';
import MakeReservation from '../reservation/MakeReservation';
import { getBarberUrls } from '../utils/helpers';
import analytics from '../applicationServices/analytics/BookingAnalytics';


export default (urlPattern) => {
  const urls = getBarberUrls(urlPattern);

  // Put component in variable to prevent re-rendering
  const BarberServices = WithBarberUrlPattern(Services);
  const DynamicBarbers = withHandlers({
    onBarberClick: () => (e, barber, shop) => {
      analytics.selectBarber(barber, { shop });
    },
  })(WithBarberUrlPattern(Barbers));

  return (
    <Route component={WithBarberUrlPattern(ShopMainLayout)}>
      <Route path={urls.barbers} component={DynamicBarbers} />
      <Route
        path={urls.services}
        component={BarberServices}
        ignoreScrollBehavior
      />
      <Route
        path={urls.pickTime}
        component={BarberServices}
        ignoreScrollBehavior
      />
      <Route
        path={urls.makeReservation}
        component={WithBarberUrlPattern(MakeReservation)}
      />
      <Redirect
        from={`${urls.makeReservation}/**`}
        to={urls.makeReservation}
      />
    </Route>
  );
};




// WEBPACK FOOTER //
// ./src/app/dynamicBooking/BarberRoutes.jsx